export const formatPrice = (amount, currency) => {
  if (!Number.isInteger(amount) || !['INR', 'USD'].includes(currency)) return '';
  return new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US', {
    style: 'currency', currency,
    minimumFractionDigits: currency === 'INR' && amount % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount / 100);
};

// Metadata and visible prices share the exact same fetched merchant catalog.
export const priceOffers = (plans, currency, url) => plans
  .filter((plan) => Number.isInteger(plan.prices?.[currency]?.amount))
  .map((plan) => ({ '@type': 'Offer', name: plan.name,
    price: (plan.prices[currency].amount / 100).toFixed(2), priceCurrency: currency, url }));

const PREFERENCE_KEY = 'careerova.currency.manual.v2';
export const readCurrencyPreference = () => {
  try {
    const value = localStorage.getItem(PREFERENCE_KEY);
    return ['INR', 'USD'].includes(value) ? value : null;
  } catch { return null; }
};
export const saveCurrencyPreference = (currency) => {
  try { localStorage.setItem(PREFERENCE_KEY, currency); } catch { /* unavailable storage is non-fatal */ }
};